import * as THREE from "three";
import type { InteractionSystem } from "../xr/input";

/**
 * Simple world-space Reset control for a single workshop station.
 * Desktop click and XR select invoke the station-local `onReset` callback
 * (not a global workshop wipe). Hands specialist may later supersede this
 * with a richer UI affordance.
 */
export function createResetPlate(
  interaction: InteractionSystem,
  onReset: () => void,
): THREE.Group {
  const group = new THREE.Group();
  group.name = "reset-plate";

  const mat = new THREE.MeshStandardMaterial({
    color: 0x243044,
    roughness: 0.55,
    metalness: 0.15,
    emissive: 0x000000,
  });
  const mesh = new THREE.Mesh(new THREE.BoxGeometry(0.28, 0.08, 0.04), mat);
  mesh.name = "reset-plate-mesh";
  mesh.castShadow = true;
  group.add(mesh);

  const label = makeLabel();
  label.position.set(0, 0, 0.022);
  group.add(label);

  interaction.register({
    object: mesh,
    onSelect: () => onReset(),
    onHover: (hovered) => {
      mat.emissive.setHex(hovered ? 0x1a3a55 : 0x000000);
      mat.color.setHex(hovered ? 0x2f4664 : 0x243044);
    },
  });

  return group;
}

function makeLabel(): THREE.Mesh {
  const canvas = document.createElement("canvas");
  canvas.width = 256;
  canvas.height = 64;
  const ctx = canvas.getContext("2d")!;
  ctx.fillStyle = "#e2e8f0";
  ctx.font = "700 36px system-ui, sans-serif";
  ctx.textAlign = "center";
  ctx.textBaseline = "middle";
  ctx.fillText("RESET", 128, 34);
  const texture = new THREE.CanvasTexture(canvas);
  texture.colorSpace = THREE.SRGBColorSpace;
  return new THREE.Mesh(
    new THREE.PlaneGeometry(0.24, 0.06),
    new THREE.MeshBasicMaterial({ map: texture, transparent: true }),
  );
}
